import { Button, Form, Input, message } from 'antd';
import { PasswordRecovery } from 'services/RecoveryPassword';
import {
  onHandlePhoneChange,
  phoneFormatterKeyDown,
} from 'utils/forms/formatter';
import { requiredRule } from 'utils/forms/validationRules';
import { RecoveryPhoneFormWrapper } from '../style';

function RecoveryPhoneForm({ setCurrentStep, setFormData }) {
  const [form] = Form.useForm();

  const onSubmit = async ({ phone }) => {
    try {
      const payload = {
        mobile_phone: phone.replace(/\D/g, ''),
      };
      const res = await PasswordRecovery.sendCode(payload);
      if (res) {
        setFormData(payload);
        setCurrentStep(1);
      } else {
        message.error('Не получилось отправить код');
      }
    } catch (err) {
      message.error('Что-то пошло не так. Попробуйте еще раз');
    }
  };

  return (
    <RecoveryPhoneFormWrapper>
      <Form
        form={form}
        onFinish={onSubmit}
        layout="horizontal"
        requiredMark={false}
        labelCol={{
          span: 5,
        }}
        wrapperCol={{
          span: 24,
        }}
      >
        <h4>Воссстановление пароля</h4>

        <div className="login-form">
          <div className="login-form__inputs">
            <Form.Item
              name="phone"
              label="Тел. номер"
              rules={[
                requiredRule,
                { len: 18, message: 'Введите полностью номер' },
              ]}
            >
              <Input
                onChange={(e) => onHandlePhoneChange(e, form)}
                onKeyDown={(e) => phoneFormatterKeyDown(e, form)}
                type="tel"
                placeholder="+ 7 ( _ _ _ ) _ _ _  _ _  _ _ "
                allowClear
              />
            </Form.Item>

            <Form.Item />

            <Form.Item
              wrapperCol={{
                offset: 5,
              }}
            >
              <Button type="primary" htmlType="submit">
                Отправить
              </Button>
            </Form.Item>
          </div>
        </div>
      </Form>
    </RecoveryPhoneFormWrapper>
  );
}

export { RecoveryPhoneForm };
